import React from "react";
import GlobalFeedback from "../../../../../global/GlobalFeedback";
import {
  GlobalButton,
  GlobalTextAreaField,
  GlobalTextField,
} from "../../../../../global/forms/GlobalFormFields";
import PaymentStrip from "../../../../payment/PaymentStrip";
import { isActivePhonePePayment } from "../../../../payment/paymentSession";
import { TRANSACTION_ID_MAX_LENGTH } from "../membershipRenewCommon";

export default function MembershipRenewPaymentSection({
  sectionRef,
  selectedRenewal,
  form,
  setForm,
  formErrors,
  phonePeCompleted,
  phonePeError,
  onPhonePeError,
  onBeforePayRedirect,
  onClearOnlinePayment,
  submitting,
  errorMsg,
  onSubmit,
}) {
  const paymentType = isActivePhonePePayment(phonePeCompleted) ? "online" : form.payment_type;

  return (
    <div className="vml-renew-payment-col">
      <section
        ref={sectionRef}
        className={`user-builder-panel ${selectedRenewal ? "" : "treg-step-section--locked"}`}
        style={{ marginTop: "1rem" }}
      >
        <div className="user-builder-panel__head">
          <h3 className="user-builder-panel__title">Payment section</h3>
          <p className="user-builder-panel__hint">
            {selectedRenewal
              ? "Pay offline or online via PhonePe, then submit renewal."
              : "Select a row and click Renewal -> Proceed Renewal to enable payment section."}
          </p>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "0.95rem" }}>
          <div className="treg-form-grid treg-form-grid--2">
            <GlobalTextField label="Student" value={selectedRenewal?.student_name || ""} onChange={() => {}} disabled />
            <GlobalTextField label="Membership" value={selectedRenewal?.membership_name || ""} onChange={() => {}} disabled />
          </div>
          <GlobalTextField
            label="Amount"
            type="number"
            value={form.amount}
            onChange={() => {}}
            error={formErrors.amount}
            disabled
          />
          <PaymentStrip
            paymentType={paymentType}
            onBeforePayRedirect={onBeforePayRedirect}
            onClearOnlinePayment={onClearOnlinePayment}
            onPaymentTypeChange={(type) => {
              setForm((f) => ({ ...f, payment_type: type, payment_transaction_id: "" }));
              onPhonePeError("");
              if (formErrors.phonepe || formErrors.payment_transaction_id) {
                // parent clears via setFormErrors in page
              }
            }}
            receiptValue={form.payment_transaction_id}
            onReceiptChange={(v) =>
              setForm((f) => ({
                ...f,
                payment_transaction_id: String(v ?? "").slice(0, TRANSACTION_ID_MAX_LENGTH),
              }))
            }
            receiptError={formErrors.payment_transaction_id || formErrors.reference}
            amount={form.amount}
            phonePeCompleted={phonePeCompleted}
            phonePeErrorMsg={phonePeError}
            onPhonePeError={onPhonePeError}
            formErrorDetails={formErrors}
            formSubmitting={submitting}
            proofUrl={form.proof}
            proofFileName={form.proof_file_name}
            proofError={formErrors.proof}
            onProofChange={({ url, fileName }) => {
              setForm((f) => ({
                ...f,
                proof: url || "",
                proof_file_name: fileName || "",
              }));
            }}
          />
          <GlobalTextAreaField
            label="Remarks"
            value={form.remarks}
            onChange={(v) => setForm((f) => ({ ...f, remarks: v }))}
            disabled={!selectedRenewal}
            rows={3}
          />
        </div>
        {errorMsg ? <GlobalFeedback type="error" text={errorMsg} /> : null}
        <div className="vml-edit-actions" style={{ marginTop: "0.95rem" }}>
          <GlobalButton type="button" variant="primary" disabled={!selectedRenewal || submitting} onClick={onSubmit}>
            {submitting ? "Submitting..." : "Submit Renewal"}
          </GlobalButton>
        </div>
      </section>
    </div>
  );
}
